import { tsValidateNumber, tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
import { EHRInstallationTypes } from './types.js';
const Validator_MandatoryPropsEHRInstallation = {
    label: tsValidateString(),
    type: tsValidateValue([...EHRInstallationTypes]),
    organizationId: tsValidateUniqueId,
    customerId: tsValidateNumber(false),
};
const Validator_GeneratedProps = {};
export const DBDef_EHRInstallation = {
    modifiablePropsValidator: Validator_MandatoryPropsEHRInstallation,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.1', '1.0.0'],
    dbKey: 'ehr-installations',
    generatedProps: [],
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'ehr-installations'
    },
    backend: {
        name: 'ehr-installations'
    },
    entityName: 'EHRInstallations',
    dependencies: {
        organizationId: {
            dbKey: 'organizations',
            fieldType: 'string',
        }
    }
};
//# sourceMappingURL=db-def.js.map